var fitt = require('fitt'),
http = require('fitt-http'),
isBrowser = process.browser,
empty = fitt.empty,
MOCK_DATA = 'mock-data',
PRODUCTION = 'production',
MUST_REVALIDATE = 'no-cache, no-store, must-revalidate',
MOCK = 'mock',
READ = 'read',
WRITE = 'write';


function getRequestHandler(options)
{
    var config = options && options.config,
    httpCollapsing = options && options.httpCollapsing || true,
    mockDataDir = options && options.mockDataDir,
    baseHttpConfig = getHttpConfig(config),
    dataHandler,
    requestHandler;

    if (isBrowser) {
        requestHandler = function (url, opts) {
            var httpConfig = opts && opts.httpConfig || baseHttpConfig;

            return http.get.call(http, url, httpConfig);
        };
    } else {

        var Cache = require('fitt-cache'),
        cache = void 0;

        if (httpCollapsing) {
            // require datahandler (server-only)
            dataHandler = require('fitt-datahandler');

            // Initialize datahandler in the cluster/fork
            dataHandler.initialize('api_message');
        } else {
            cache = new Cache();
        }

        requestHandler = function (url, opts) {
            var cachePolicy = opts && opts.cachePolicy,
            httpConfig = opts && opts.config || baseHttpConfig,
            mockData = opts && opts.mockData,
            ret;

            httpConfig = httpConfig || baseHttpConfig;

            if (!empty(mockData) && process.env.NODE_ENV !== PRODUCTION) {
                var Path = require('path'),
                dataParam = mockData && mockData.type,
                resource = mockData && mockData.resource,
                endpoint = mockData.endpoint || '',
                mockfileName = mockData.fileName || '',
                endpoints = endpoint.split(','),
                fileNames = mockfileName.split(','),
                resourceIdx = endpoints.indexOf(resource),
                fileName = void 0;

                mockDataDir = mockDataDir || Path.resolve(process.cwd(), MOCK_DATA);

                if (resourceIdx > -1 && fileNames.length > resourceIdx) {

                    // grab corresponding file name
                    fileName = fileNames[resourceIdx];

                    // if the provided endpoint matches the name of the resource currently being requested
                    if (dataParam === MOCK || dataParam === READ) {

                        url = Path.resolve(mockDataDir, fileName);
                        cachePolicy = MUST_REVALIDATE;

                        httpConfig =
                        {
                            dispatch: MOCK };


                    } else if (dataParam === WRITE) {

                        httpConfig =
                        {
                            writeResponse:
                            {
                                path: Path.resolve(mockDataDir, fileName) } };


                    }
                }
            }

            if (httpCollapsing) {
                ret = dataHandler.makeRequest(url, cachePolicy, httpConfig);
            } else {
                ret = cache.getHttp(url, httpConfig, cachePolicy);
            }

            return ret;
        };
    }

    return requestHandler;
}

function getHttpConfig(options)
{
    var httpConfig = options && options.config,

    attempts,tracing,timeout,dnsTimeout,
    serverTimeout,clientTimeout;

    if (httpConfig) {
        return httpConfig;
    }

    attempts = options && options.attempts || 2,
    tracing = options && options.tracing || false,
    timeout = options && options.timeout,
    dnsTimeout = timeout && timeout.dns || 2000,
    serverTimeout = timeout && timeout.server || 5000,
    clientTimeout = timeout && timeout.client || 10000;

    if (isBrowser) {

        httpConfig =
        {
            attempts: attempts,
            timeout: clientTimeout };


    } else {

        httpConfig =
        {
            headers:
            {
                'Accept-Encoding': 'gzip,deflate' },

            timeout: serverTimeout,
            dnsTimeout: dnsTimeout,
            attempts: attempts,
            tracing: tracing };


    }

    return httpConfig;
}

module.exports = getRequestHandler;


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-shell/getRequestHandler.js
// module id = 752
// module chunks = 0